<template>
    <div class="modal fade reviewreminderbox" id="tutorialmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="tutorial-modal-content" :class="tutorialphase == 1 ? 'dark-sky' : tutorialphase == 2 ? 'light-sky' : ''">

                <div v-if="tutorialphase == 1" class="animated fadeIn container-fluid transit popup-box tutorialmodal-text p-4" v-html="locale.tutorial1_text"></div>
                <div v-else-if="tutorialphase == 2">
                    <img class="sun" src="@/assets/sun.svg"/>
                    <div class="animated fadeInRight container-fluid transit popup-box tutorialmodal-text-2 p-4" v-html="locale.tutorial2_text"></div>
                </div>
                <div v-else>
                    <img data-v-75064461="" id="tutendicon3" data-imageurl="https://lh3.googleusercontent.com/-h5v6VfKHCCLPQ1m9bR8Ya2hyCVCBEISbXJDXYL_ZQgRw7FFeLAvvADbSUHP8PQv5J0=w300" src="https://lh3.googleusercontent.com/-h5v6VfKHCCLPQ1m9bR8Ya2hyCVCBEISbXJDXYL_ZQgRw7FFeLAvvADbSUHP8PQv5J0=w300" class="animated fadeInDown tutendicon">
                    <img data-v-75064461="" id="tutendicon2" data-imageurl="https://lh3.googleusercontent.com/pSsW7GbDpK4touXs5tlQY2Jo96UlLU0FAmndURGevfAyHOH6GR_KPc9RNYB0knHV2Tc=w300" src="https://lh3.googleusercontent.com/pSsW7GbDpK4touXs5tlQY2Jo96UlLU0FAmndURGevfAyHOH6GR_KPc9RNYB0knHV2Tc=w300" class="animated fadeInDown tutendicon">
                    <img data-v-75064461="" id="tutendicon1" data-imageurl="https://lh3.googleusercontent.com/TpJB0_3h60fY_t6et1KKv974M22YLBfCEzlNJpOipoetSXRJqqPwOkyTOzGc66SSgt5Z=s180" src="https://lh3.googleusercontent.com/TpJB0_3h60fY_t6et1KKv974M22YLBfCEzlNJpOipoetSXRJqqPwOkyTOzGc66SSgt5Z=s180" class="animated fadeInDown tutendicon">
                    <img id="arrow1" class="animated fadeInDown arrow" src="@/assets/arrow.svg"/>
                    <img id="arrow2" class="animated fadeInDown arrow" src="@/assets/arrow.svg"/>
                    <img id="arrow3" class="animated fadeInDown arrow" src="@/assets/arrow.svg"/>
                    <!-- <h5 class="tut_description mx-4" v-html="locale.tutorial3_text"></h5> -->
                    <div class="tut-trees-container">
                        <img id="tuttree1" class="spawned-tree img-responsive" src="../assets/light-tree.svg" />
                        <img id="tuttree2" class="spawned-tree img-responsive" src="../assets/light-tree.svg" />
                        <img id="tuttree3" class="spawned-tree img-responsive" src="../assets/dark-tree.svg" />
                        <img id="tuttree4" class="spawned-tree img-responsive" src="../assets/light-tree.svg" />
                        <img id="tuttree5" class="spawned-tree img-responsive" src="../assets/light-tree.svg" />
                    </div>
                </div>
                <img v-if="tutorialphase <= 2" class="tutorial-trees" src="@/assets/tut_img_1.svg"/>
                <img v-if="tutorialphase == 2" class="tutorial-appearing-trees animated fadeIn" src="@/assets/tut_img_2_onlyappleshalf_wo_ground.svg"/>
                <button @click="nextPhase" :class="{'notphase1' : tutorialphase >= 2}" :style="tutorialphase == 3 ? 'color: white; background-color: #BADC58' : ''" class="px-4 next-btn" v-html="tutorialphase == 3 ? locale.discover : locale.next"></button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'app',
    data() {
        return {
            locale: this.$locale.tutorial,
            tutorialphase: 1
        }
    },
    methods:{
        nextPhase(){
            if(this.tutorialphase > 2){
                window.$('#tutorialmodal').modal('hide');
                localStorage.tutorialDone = true;
                this.tutorialphase = 1
            }
            else
                this.tutorialphase++;
        }
    }
}
</script>
<style scoped lang="scss">
    .tut_description{
        bottom: 20rem;
        position: absolute;
    }

    .tutorial-modal-content {
        position: relative;
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-direction: column;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        flex-direction: column;
        width: 100%;
        pointer-events: auto;
        background-color: #fff;
        /* background-clip: padding-box;
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 0.3rem; */
        outline: 0;
        background-color: #f1f1f1;

        // -webkit-animation: bgcolor 10s infinite;
        // animation: bgcolor 10s infinite;
        -webkit-animation-direction: alternate;
        animation-direction: alternate;

        &.dark-sky{
            -webkit-animation: bgcolor-dark 10s infinite;
            animation: bgcolor-dark 10s infinite;
        }
        &.light-sky{
            // -webkit-animation: bgcolor-light 10s infinite;
            // animation: bgcolor-light 10s infinite;
            // background: linear-gradient(140deg, rgba(6,147,147,1) 0%, rgba(126,255,255,1) 57%, rgba(8,255,255,1) 100%);
            background: linear-gradient(160deg, rgba(6,147,147,1) 0%, rgba(126,255,255,1) 72%, rgba(8,255,255,1) 100%);
        }

        /* per farlo fullscreen: */

        height: -webkit-fill-available;
    }

    .tutorialmodal-text{
        position: relative;
        color: white;
        /* font-size: 1.3rem; */
        font-size: 1.5rem;
        /* font-weight: bold!important; */
        margin-bottom: 0.5rem;
        margin-top: 30%;
        font-weight: lighter;
        line-height: 1.2;
        z-index: 100;
        // -webkit-box-shadow: inset 4px 7px 109px 26px rgba(0,0,0,0.08);
        // -moz-box-shadow: inset 4px 7px 109px 26px rgba(0,0,0,0.08);
        // box-shadow: inset 4px 7px 109px 26px rgba(0,0,0,0.08);
    }

    .tutorialmodal-text-2{
        position: relative;
        color: white;
        /* font-size: 1.3rem; */
        font-size: 1.5rem;
        /* font-weight: bold!important; */
        margin-bottom: 0.5rem;
        margin-top: 15%;
        font-weight: lighter;
        line-height: 1.2;
        z-index: 100;

        text-shadow: 0px 0px 12px rgba(0,0,0,0.6);

        // -webkit-box-shadow: inset 4px 7px 109px 26px rgba(0,0,0,0.08);
        // -moz-box-shadow: inset 4px 7px 109px 26px rgba(0,0,0,0.08);
        // box-shadow: inset 4px 7px 109px 26px rgba(0,0,0,0.08);
    }

    @keyframes bgcolor-dark {
        0% {
            background-color: #606060
        }

        50% {
            background-color: #262626
        }

        100% {
            background-color: #606060
        }
    }

    @keyframes bgcolor-light {
        0% {
            // background-color: #7effff
            background: rgb(64,128,128);
            // background: linear-gradient(140deg, rgba(64,147,147,1) 0%, rgba(126,255,255,1) 57%, rgba(126,255,255,1) 100%);
        }

        50% {
            // background-color: #08ffff
            background: rgb(6,147,147);
            // background: linear-gradient(140deg, rgba(6,147,147,1) 0%, rgba(126,255,255,1) 57%, rgba(8,255,255,1) 100%);
            // background: linear-gradient(180deg, rgba(64,147,147,1) 0%, rgba(126,255,255,1) 57%, rgba(126,255,255,1) 100%);
        }

        100% {
            // background-color: #7effff
            background: rgb(64,128,128);
            // background: linear-gradient(140deg, rgba(64,147,147,1) 0%, rgba(126,255,255,1) 57%, rgba(126,255,255,1) 100%);
        }
    }

    .next-btn{
        position: absolute;
        align-self: center;
        color: black;
        background-color: white;
        /* bottom: 2.5rem; */
        bottom: 35vh;
        /* color: #fff; */
        /* background-color: #548C3C;
        border-color: #548C3C; */

        display:inline-block;
        padding:0.35em 1.2em;
        border:0.1em solid #FFFFFF;
        margin:0 0.3em 0.3em 0;
        /* border-radius:0.12em; */
        border-radius: 1.2em;
        box-sizing: border-box;
        text-decoration:none;
        font-family:'Roboto',sans-serif;
        font-weight:300;
        text-align:center;
        transition: all 0.2s;

        &.notphase1{
            bottom:15vh;
        }
    }

    .modal-dialog{
        margin: 0
    }

    .tutorial-trees{
        position: absolute;
        bottom: 0;
    }

    .tutorial-appearing-trees{
        position: absolute;
        bottom: 0;
    }

    .btn-next:hover{
        color:#000000;
        background-color:#FFFFFF;
    }
    @media all and (max-width:30em){
        btn-next{
            display:block;
            margin:0.4em auto;
        }
    }

    .sun{
        position: absolute;
        top: -50vw;
        right: -50vw;

        -webkit-animation: sun-motion ease-in-out 7s infinite;
        animation: sun-motion 7s ease-in-out infinite;
    }

    @keyframes sun-motion {
        0% {
            top: -50vw;
            right: -50vw;
        }

        50% {
            transform: translate(20px, -20px);
        }

        100% {
            top: -50vw;
            right: -50vw;
        }
    }

    .tutendicon{
        border-radius: 20px;
        max-width: 25vw;
        position: absolute;

        &#tutendicon2{
            top: 10rem;
            left: 40%;
        }

        &#tutendicon3{
            top: 7rem;
            right: 12vw;
            max-width: 20%;
        }

        &#tutendicon1{
            top: 6rem;
            left: 21vw;
            max-width: 23%;
        }
    }

    .arrow{
        border-radius: 20px;
        max-width: 25vw;
        position: absolute;

        &#arrow1{
            max-width: 15vw;
            top: 18rem;
            left: 45vw;
        }

        &#arrow2{
            top: 13rem;
            right: 13vw;
            max-width: 16vw;
        }

        &#arrow3{
            top: 13rem;
            left: 21vw;
            max-width: 22vw;
        }
    }


.tut-trees-container{
        height:5rem;
        transition: all .3s cubic-bezier(.6,0,.45,1.3);
    }

.spawned-tree{
    transform-origin:50% 100%;
    -moz-transform-origin:50% 100%;
    animation: appear 1s 1, grow 3s infinite;
    transform-box: fill-box;
    animation-timing-function: cubic-bezier(.63,.09,.3,1.43);
    animation-fill-mode:forwards;
    transform:scale(0);
    // position:relative;
    position:absolute;
    transition: all .5s cubic-bezier(.6,0,.45,1.3);
  }

    /*Keyframes*/
@keyframes appear {
    0%   {transform:scaleX(0) scaleY(0) translateY(0)}
    70%  {transform:scaleX(0.7) scaleY(0.7) translateY(0)}
    80%  {transform:scaleX(0.9) scaleY(0.5) translateY(5px)}
    100% {transform:scaleX(1) scaleY(1) translateY(0)}
}

/*Keyframes*/
@keyframes grow {
    0% {transform:scaleX(1) scaleY(1) translateY(0)}
    50%  {transform:scaleX(0.95) scaleY(0.9) translateY(1px)}
    100% {transform:scaleX(1) scaleY(1) translateY(0)}
}

        #tuttree1{
            height: inherit;
            bottom: 14rem;
            left: 18%;
            animation-delay: 0s, 1s;
        }
        #tuttree2{
            height: inherit;
            // margin-left: 0.5rem;
            // margin-bottom: 0.2rem;
            bottom: 13rem;
            left: 32%;
            // right:auto;
            animation-delay: 0.3s, 1.3s;
        }
        #tuttree3{
            height: inherit;
            // margin-left: 0.5rem;
            // margin-bottom: 0.4rem;
            bottom: 13.5rem;
            left: 46%;
            animation-delay: 0.6s, 1.6s;
        }
        #tuttree4{
            height: inherit;
            // margin-left: 0.5rem;
            // margin-bottom: 0.6rem;
            bottom: 15rem;
            left: 60%;
            // right:auto;
            animation-delay: 0.9s, 1.9s;
        }
        #tuttree5{
            height: inherit;
            // margin-left: 0.7rem;
            // margin-bottom: 0.1rem;
            bottom: 14.5rem;
            left: 73%;
            animation-delay: 1.2s, 2.2s;
        }

</style>